import React from "react";
import "./ServicePages.css";

const SocialMediaMarketing = () => {
  return (
    <section className="service-page">
      <div className="service-hero">
        <h1>Social Media Marketing</h1>
        <p>
          Growing educational brands through strategic content
          and engagement.
        </p>
      </div>

      <div className="service-content">
        <h2>What We Manage</h2>
        <div className="service-grid">
          <div className="service-card">Content Creation</div>
          <div className="service-card">Post Scheduling</div>
          <div className="service-card">Audience Engagement</div>
          <div className="service-card">Analytics & Growth</div>
        </div>

        <div className="service-cta">
          <button>See Social Media Work</button>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaMarketing;
